export enum Rating {
    // APlus1 = 'A+1', APlus2 = 'A+2', APlus3 = 'A+3',
    A1 = 'A1', A2 = 'A2', A3 = 'A3', A4 = 'A4', A5 = 'A5', A6 = 'A6',
    B1 = 'B1', B2 = 'B2', B3 = 'B3', B4 = 'B4', B5 = 'B5', B6 = 'B6',
    C1 = 'C1', C2 = 'C2', C3 = 'C3', C4 = 'C4', C5 = 'C5', C6 = 'C6'
}

export interface PreferredCategories {
    ratingList: Rating[];
}

export interface PortfolioPreferences {
    portfolioId?: string;
    preferredCategories: PreferredCategories[];
}
